import React from "react";
import { FiTrash2 } from "react-icons/fi";

const DeleteModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[10000] overflow-y-auto">
      <div 
        className="fixed inset-0 bg-black opacity-50 backdrop-blur-sm"
        onClick={onClose}
      ></div>
      <div className="flex items-center justify-center min-h-screen p-4">
        <div className="relative bg-white rounded-2xl shadow-xl max-w-sm w-full p-6 text-center animate-in fade-in zoom-in duration-200">
          <div className="mb-4">
            <div className="w-20 h-20 bg-red/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <FiTrash2 className="w-10 h-10 text-red" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 leading-tight">Are you sure?</h3>
            <p className="text-gray-500 mt-2 text-sm">
              Do you really want to delete this data? This action cannot be undone.
            </p>
          </div>
          <div className="flex items-center justify-center space-x-3 mt-6">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl text-gray-700 hover:bg-gray-50 transition-all font-semibold text-sm active:scale-95"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="flex-1 px-4 py-2.5 bg-red text-white rounded-xl hover:bg-red-600 transition-all font-semibold text-sm shadow-md shadow-red/20 active:scale-95"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
